import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Spinner,Form } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postDataUser } from '../ApiServices/ApiService';
// import { BsMic } from 'react-icons/bs';
import { FaStop, FaMicrophone,FaVideo } from "react-icons/fa";
//import axios from 'axios';
import Logo from '../assets/icons/logo2.jpeg';
import UserNav from './UserNav';
import { async } from 'q';

const UsersQuestions = () => {
  const [searchParams] = useSearchParams();
  const testId = searchParams.get('id');
  const navigate = useNavigate();
  const [isRecording, setIsRecording] = useState(false);
  const [audioChunks, setAudioChunks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isGetAns, setIsGetAns] = useState(false);

  const audioStreamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const mediaVideoRecorderRef = useRef(null);
  const videoRef = useRef(null);
  const chunksRef = useRef([]);

  const [questions, setQuestions] = useState([]);
  
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  var testTime= "";
  const [timer, setTimer] = useState(null); // 3 minutes in seconds
  const [fetchedTestTimeId, setFetchedTestTimeId] = useState(null);
  // const [startTime, setStartTime] = useState(Date.now());
  // const [endTimeInMilliseconds, setEndTimeInMilliseconds] = useState(0);

  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [isTimerRunning, setIsTimerRunning] = useState(true);
  const [error, setError] = useState('Loading ...');
  const [respError, setRespError] = useState('');
  const [urls, setUrls] = useState([]);
  const [firstQuestion,setFirstQuestion] = useState(null)

  const startCapture = (qid,url) => {
    console.log("qid", qid)
    navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      .then((stream) => {
        videoRef.current.srcObject = stream;
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.muted = true;
          videoRef.current.play();
          mediaVideoRecorderRef.current = new MediaRecorder(stream);
          const chunks = [];
          mediaVideoRecorderRef.current.ondataavailable = (event) => {
            if (event.data.size > 0) {
              chunks.push(event.data);
            }
          };
  
          mediaVideoRecorderRef.current.onstop = () => {
            const blob = new Blob(chunks, { type: 'video/webm' });
            sendVideoBlobToBackend(blob,firstQuestion);
            console.log("chunks",chunks);
            console.log("video", blob);
          };
  
          mediaVideoRecorderRef.current.start();
        };
      })
      .catch((err) => {
        console.error('Error accessing the camera:', err);
      });
  };
  
  useEffect(() => {
      startCapture();
  }, []);

  const stopCapture = () => {
    mediaVideoRecorderRef.current.stop();
  
    const stream = videoRef.current.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => {
        if (track.kind === "video") {
          track.stop(); // Stop video track
        } else if (track.kind === "audio") {
          track.stop(); // Stop microphone track (if used)
        }
      });
    }
  
    videoRef.current.srcObject = null;
  };

  // const stopCapture = () => {
  //   if (videoRef.current) {
  //     const stream = videoRef.current.srcObject;
  //     if (stream) {
  //       const tracks = stream.getTracks();
  //       tracks.forEach((track) => {
  //         track.stop();
  //       });
  //     }
  //     videoRef.current.srcObject = null;
  //   }
  // };

  const [checkQuestion, setCheckQuestion] = useState(false);
  useEffect(() => {
    if (questions.length > 0) {
        setFirstQuestion(questions[0]);
    }
}, [questions,checkQuestion]);

// console.log('firstQuestion:', firstQuestion);

  const sendVideoBlobToBackend = async (blob,firstQuestion) => {
    let videourl
    let storedValue = localStorage.getItem("1stQuestion");
      if (storedValue) {
          let parsedValue = JSON.parse(storedValue);
          console.log("parsedValue", parsedValue);
          if (firstQuestion === undefined || firstQuestion === null) {
            setCheckQuestion(true);
            console.log('firstindex:1', firstQuestion);
            videourl = parsedValue;
        } else {
            videourl = questions[currentQuestionIndex + 1];
        }
      } else {
          console.log("No value found for key '1stQuestion' in localStorage.");
      }
    // if(firstQuestion === undefined || firstQuestion === null){
    //   setCheckQuestion(true);
    //   console.log('firstindex:1', firstQuestion);
    //   videourl = questions[currentQuestionIndex + 1]

    // }else{
    //   console.log('firstindex:0', firstQuestion);
    //   videourl = questions[currentQuestionIndex + 1]
    // }
    console.log("current video url", videourl)
    // return
    // const videoBloburl = https://ai-recruiter.s3.amazonaws.com/videos/t_id_2024031919113352555302/1?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA6N2VA2PSQGKMPCGP%2F20240319%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20240319T113425Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEOT%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMiJGMEQCICZGYl42IEbo9uCFObopj7Nw0S51%2FZnllvBe%2BJh1WiZ0AiA3p8g%2FrgYKC%2BflzcttXShBjGeFKwroBuLv2lVc4DPwOyqUAwjt%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAEaDDk5MTc3ODg4NjYyOSIM%2BqqmB0TjFe3UNRuqKugC2jEgjZcK0NO0H6QikvPN1FcdsuVby4cFBy0nP2GUgNEn4IMHB1aCyaXy%2FfvlAIwhSOWhjXlzL1e7qLPQHiUFrChqK%2FIldmeGTBdsgxY49QyX8HskQUhsJeiiLk21e1c0zRutQGHrPV7pDFL1ppbLFeD%2F1DnoCky2sQnrcwhW9HmYllUe1qzuQ90p8Piq7SDZAutwJ1ca31J2F6NvbDzDMH%2BLKtLxy8Ik%2BWE0iDLyRaPWNB9RwDHxQDe%2Bb8%2BP5FwNKfO2x66F52mSc0d7VfqVoVKWaRFrlHOmlJeK6D59JViCpdTcG4M3Lxh03%2FLr7FQxZ9e8ZOOpjQHuH7sZ%2F%2BtPVqMzvfOTKddl2Z2po6gxjuaGWiWYKc1gTWvlz1yJFcMtKTTKgNBsl%2FLVeIiXlg4D3Tawe8qi2yhTgeB1H6cVOunIOgKC0xRKpaacSF%2Byy7K09Wm1gG5UzwUCO2l8YaNfiwMRmAXoKjU2MLzw5a8GOp4BpbgM6lXECnX8yRme%2BjXfI4GwM73O9tOb4zDmaI4sTom1RhlKdFlWIQhmqS%2BHva%2FGxMgUelzW039DNQxM1IFhscBIG465b1f8UHgyazeeq6vg3x2SzLt3BBNWQ%2FWma9c%2FH14A1TiyTA93PxTPulBxouHF5MDpVNqTFrIV6HADduN%2F554kP2XLjvhu4JoV5iUgDz4obQOHv7JjXLxNauw%3D&X-Amz-Signature=71232875176139de41557232d55a0cbcebb37276b80b3c8c42351d354024d10b
    try {
        console.log("video url's", videourl)
        // if (videourl) {
          const fields = videourl.video_url.fields;
          console.log("fields", fields)
          const url = videourl.video_url.url;
          const formData = new FormData();
          
            formData.append('key', fields.key);
            formData.append('x-amz-security-token', fields['x-amz-security-token']);
            formData.append('x-amz-signature', fields['x-amz-signature']);
            formData.append('policy', fields.policy);
            formData.append('x-amz-algorithm', fields['x-amz-algorithm']);
            formData.append('x-amz-date', fields['x-amz-date']);
            formData.append('x-amz-credential', fields['x-amz-credential']);
            formData.append('file', blob);
        
            console.log(formData);

            const presignedResp = await fetch(url, {
                method: 'POST',
                body: formData,
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                },
            });

            if (presignedResp.status === 204) {
                // setSucMsg("File Uploaded Successfully");
                // setLoading(false);
                // Remove the URL from the array if upload is successful
                // setUrls(prevUrls => prevUrls.filter(u => u !== videourl));
            } else {
                // setLoading(false);
                // console.log("Presigned URL request failed:", presignedResp.status);
            }
        // }
    } catch (error) {
        // setLoading(false);
        // setSuccess("Failed To Upload File");
        console.error('Error:', error);
    }
};

useEffect(() => {
  console.log("urls:", urls);
}, [urls]);
  
  const [questionChunksList, setQuestionChunksList] = useState([]);

  useEffect(() => {
    if (fetchedTestTimeId !== null) {
      setTimer(fetchedTestTimeId); 
    }
  }, [fetchedTestTimeId]);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        setLoading(true);
        const payload = {"test_id": testId,}
        postDataUser('candidate_test_questions_get', payload).then(resp => {
          resp.json().then(respData => {
            if (resp.status === 200) {
              if (respData.statusCode === 200) {
                if (respData.message.toLowerCase() === 'success') {
                  if (respData.dataJ.questions.length > 0) {
                     testTime = parseInt(respData.dataJ.test_time);
                    // setTimer(testTime);
                    setFetchedTestTimeId(testTime);
                    setLoading(false);
                    setError('')
                    setQuestions(respData.dataJ.questions);
                    setFirstQuestion(respData.dataJ.questions[0]);
                    localStorage.setItem("1stQuestion", JSON.stringify(respData.dataJ.questions[0]));
                    setTotalQuestions(respData.dataJ.questions.length);
                    if(respData.dataJ.questions.length === 1){
                      setShowSubmitButton(true)
                    }
                  //   for (const question of respData.dataJ.questions) {
                  //     const url = question.video_url;
                  //     setUrls(prevUrls => [...prevUrls, url]);
                  //     // console.log("url from question", urls);
                  // }
                  } else {
                    if (respData.info.toLowerCase() === 'questions are being generated') {
                      if(respData.dataJ.test_status !== 'failed'){
                        setTimeout(() => {
                          fetchQuestions();
                        }, 10000);
                        setError("Questions Loading... Thanks for your patience!");
                      }else{
                        setLoading(false);
                        setError('Test has been failed please contact your recruiter');
                      }
                      // setTimeout(() => {
                      //   fetchQuestions();
                      // }, 5000);
                    }else{
                      setError(respData.info);
                    }
                    // 
                  }
                } else {
                  setError(respData.info);
                  setLoading(false);
                }
              } else if(respData.statusCode === 500){
                setError(respData.info)
                setLoading(false);
              }else{
                setLoading(false);
                setError('Network Error');
              }
            } else if (resp.status === 401 || resp.status === 403) {
              console.log('resp status else if : ', resp.status);
              if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                || respData.message === 'Access Denied') {
                  setLoading(false);
                //   callRefreshTokenApi('getSfeBatch', '');
              }
            }else {
              console.log('resp status else  : ', resp);
              setLoading(false);
            }
          }).catch((error) => {
            setError('Network Error');
            console.log('network error:', error);
            setLoading(false);
          });
        }).catch((error) => {
          setError('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });


      } catch (error) {
        console.error('Error fetching questions:', error);
        setLoading(false);
      }

    };

    fetchQuestions();
  }, []);

  useEffect(() => {
    let timerId;
    if (isTimerRunning && timer > 0) {
      timerId = setTimeout(() => setTimer(timer - 1), 1000);
    } else if (timer <= 0) {
       handleRecordingStop();
      let totalQuestion = totalQuestions - 2;
      if (currentQuestionIndex > totalQuestion) {
        //End of total test
       
        // handleSubmit();
      } else {
    // nextType ==> LAST,NORMAL,BUTTON
    //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
        // handleNextQuestion("NORMAL","AUTOSUBMIT"); //Automatic Submit and Normal
      }
    } else {
      console.log('not 0');
    }

    return () => clearTimeout(timerId);
  }, [timer, isTimerRunning]);



  const handleRecordingStart = async () => {
    console.log("handleRecordingStart()............................");
    setAudioChunks([]);
    try {
      audioStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(audioStreamRef.current);

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) {
          const audioBlob = new Blob([e.data], { type: 'audio/wav' });
          // setAudioChunks((prevChunks) => [...prevChunks, e.data]);
          const reader = new FileReader();
          reader.onload = () => {
            console.log("handleRecordingStart onstop() onload()");
            const base64String = reader.result.split(',')[1];
            convertBlobToText(currentQuestion?.qid, base64String);
            console.log("base64String", base64String);
          };
          reader.readAsDataURL(audioBlob);
          setQuestionChunksList((prevList) => [...prevList, e.data]);

        }
      };

      mediaRecorderRef.current.onstop = () => {
        console.log("handleRecordingStart onstop()");
        // setAudioChunks((prevChunks) => {
        //   console.log("handleRecordingStart onstop() setAudioChunks()");
        //   const audioBlob = new Blob(prevChunks, { type: 'audio/wav' });
        //   const reader = new FileReader();
        //   reader.onload = () => {
        //     console.log("handleRecordingStart onstop() onload()");
        //     const base64String = reader.result.split(',')[1];
        //     convertBlobToText(currentQuestion?.qid, base64String);
        //   };
        //   reader.readAsDataURL(audioBlob);
        //   setQuestionChunksList((prevList) => [...prevList, ...prevChunks]);

        //   return prevChunks; // Return the new state
        // });

      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };


  //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
  const handleRecordingStop = (stopMicTypes) => {
    console.log("handleRecordingStop()............................",stopMicTypes);
    if (mediaRecorderRef.current) {
      //console.log('mic stop')
      mediaRecorderRef.current.stop();
      if (audioStreamRef.current) {
        audioStreamRef.current.getTracks().forEach((track) => track.stop());
      }
      setIsRecording(false);
      //console.log('onstop audioChunks:new ', audioChunks);
    } else {
      console.error('mediaRecorderRef.current', mediaRecorderRef.current);
    }
  };

  const handleMicClick = () => {
    if (isRecording) {
      handleRecordingStop("MIC");
    } else {
      handleRecordingStart();
    }
  };

  const handleNextQuestion = async (nextType,stopMicType) => {
    // nextType ==> LAST,NORMAL,BUTTON
    //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
    handleRecordingStop("SUBMIT");   
    stopCapture();
    startCapture();
    console.log('handleNextQuestion  nextType:', nextType," stopMicType:",stopMicType," questionChunksList:" ,questionChunksList);
    const audioBlob = new Blob(questionChunksList, { type: 'audio/wav' });
    const reader = new FileReader();
    reader.onload = () => {
      console.log("handleNextQuestion()");
      const base64String = reader.result.split(',')[1];
      convertBlobToTextFinal(currentQuestion?.qid, base64String);
    };
    reader.readAsDataURL(audioBlob);
    setQuestionChunksList([]);
    setAudioChunks([]);
    console.log('setAudioChunks []', audioChunks);

    // nextType ==> LAST,NORMAL,BUTTON
    if(nextType !== "LAST"){
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      setShowSubmitButton(false);
      setTimer(fetchedTestTimeId);
      // setnextTimer(testTime);
      let totalQuestion = totalQuestions - 3;
      if (currentQuestionIndex > totalQuestion) {
        setShowSubmitButton(true);
      }
    }


  };


  const convertBlobToText = async (qId, blobAudio) => {  
    const payload = {
      "op":"audio_trans",
      "test_id": testId,
      "qid": qId,
      "audio_data": blobAudio
    }
    setIsGetAns(true)
    postDataUser('candidate_audio_transcription', payload).then(resp => {
      resp.json().then(respData => {        
        setIsGetAns(false)
        if (resp.status === 200) {
          if (respData.statusCode === 200) {
            const questionIndex = questions.findIndex((question) => question.qid === respData.dataJ.qId);

            // If the question is found, update its answer to an empty string
            if (questionIndex !== -1) {
              const updatedQuestions = [...questions];
              updatedQuestions[questionIndex] = {
                ...updatedQuestions[questionIndex],
                q_answer: updatedQuestions[questionIndex].q_answer + ' '+ respData.dataJ.q_answer,// (for concatenate existing and New)
              };
              setQuestions(updatedQuestions);
            }
 
          } else if(respData.statusCode === 500) {
            setError(respData.info);
          }else{
            setError('Network Error');
          }
        } else if (resp.status === 401 || resp.status === 403) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
            //   callRefreshTokenApi('getSfeBatch', '');
          }
        } else {
          console.log('resp status else  : ', resp);
        }
      }).catch((error) => {
        setIsGetAns(false)
        setError('Network Error');
        console.log('network error:', error);
      });
    }).catch((error) => {
      setError('Network Error');
      setIsGetAns(false)
      console.log('network error:', error);
    });
  }

  const convertBlobToTextFinal = async (qId, blobAudio) => {
    console.log('Service convertBlobToTextFinal qId', qId, 'blobAudio',);    
    const payload = {
      "op":"audio_trans_final",
      "test_id": testId,
      "qid": qId,
      "audio_data": blobAudio
    }
    postDataUser('candidate_audio_transcription', payload).then(resp => {
      resp.json().then(respData => {
        if (resp.status === 200) {
          if (respData.statusCode === 200) {
            const questionIndex = questions.findIndex((question) => question.qid === respData.dataJ.qId);

            // If the question is found, update its answer to an empty string
            if (questionIndex !== -1) {
              const updatedQuestions = [...questions];
              updatedQuestions[questionIndex] = {
                ...updatedQuestions[questionIndex],
                q_answer: respData.dataJ.q_answer,// (for New)
              };
              setQuestions(updatedQuestions);
            }
 
          } else if(respData.statusCode === 500) {
            setError(respData.info);
            console.log('resp else  : ', resp.info);
          }else{
            setError('Network Error');
          }
        } else if (resp.status === 401 || resp.status === 403) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
            //   callRefreshTokenApi('getSfeBatch', '');
          }
        }else {
          console.log('resp status else  : ', resp);
        }
      }).catch((error) => {
        setError('Network Error');
        console.log('network error:', error);
      });
    }).catch((error) => {
      setError('Network Error');
      console.log('network error:', error);
    });
  }


  //Last Question Submit
  const handleSubmit = async () => {
    //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
    handleRecordingStop("SUBMIT");
    handleNextQuestion("LAST","AUTOSUBMIT");//LAST,NORMAL,BUTTON
    stopCapture();
    setLoading(true);
    setTimeout(async () => {
      const formattedAnswers = questions.map((question, index) => ({
        qid: question.qid,
        q_text: question.q_text,
        q_answer: question?.q_answer || 'candidate didn’t answer', // Use the user's answer if available, otherwise an empty string
        q_tech:question.q_tech,
        tech_level:question.tech_level
      }));
      try {
        const payload = {
          test_id: testId,
          questions_answers: formattedAnswers
        };
        
        // return

        await postDataUser('candidate_submit_answers', payload).then(resp => {
          setLoading(false);
          resp.json().then(respData => {
            if (resp.status === 200) {
              if (respData.statusCode === 200) {
                if (respData.message.toLowerCase() === 'success') {
                  navigate(`/users-summary?id=${payload.test_id}`);
                  // window.location.reload();
                  setCurrentQuestionIndex(0);
                  setShowSubmitButton(false);
                  setIsTimerRunning(false);

                } else {
                  setRespError(resp.info);
                  console.log('resp else s : ', resp.info);
                }
              } else if(respData.statusCode === 500){
                setRespError(resp.info);
                console.log('resp else  : ', resp.info);
              }else{
                setRespError('Network Error');
              }
            } else if (resp.status === 401 || resp.status === 403) {
              console.log('resp status else if : ', resp.status);
              if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                || respData.message === 'Access Denied') {
                //   callRefreshTokenApi('getSfeBatch', '');
                setRespError(resp.message);
              }
            }else {
              setRespError(resp.info);
              console.log('resp status else  : ', resp);
            }
          }).catch((error) => {
            setRespError(error);
            console.log('network error:', error);
          });
        }).catch((error) => {
          setLoading(false);
          setRespError(error);
          console.log('network error:', error);
        });
        // Send all responses to your API


      } catch (error) {
        console.error('Error submitting answers:', error);
        // Optionally, you can reset the state or navigate to a new page after submitting
        setCurrentQuestionIndex(0);
        setShowSubmitButton(false);
        setIsTimerRunning(false);
      }
    }, 2000);

  };

  // useEffect(() => {
  //   setEndTimeInMilliseconds(30 * totalQuestions * 1000);
  // }, [totalQuestions]);
  
  // useEffect(() => {
  //   let interval;
  //   console.log('endTimeInMilliseconds', endTimeInMilliseconds);
  //   if (endTimeInMilliseconds > 0) {
  //     interval = setInterval(() => {
  //       setEndTimeInMilliseconds((prevTime) => {
  //         const updatedTime = prevTime - 1000;
    
  //         if (updatedTime <= 0) {
  //           handleSubmit();
  //           clearInterval(interval);
  //           return 0;
  //         }
    
  //         return updatedTime;
  //       });
  //     }, 1000);
  //   }
  
  //   return () => clearInterval(interval);
  // }, [handleSubmit, endTimeInMilliseconds]);
  
  

  const handleClearAns = (qId) => {
    // Find the index of the question with the specified qid
    const questionIndex = questions.findIndex((question) => question.qid === qId);

    // If the question is found, update its answer to an empty string
    if (questionIndex !== -1) {
      const updatedQuestions = [...questions];
      updatedQuestions[questionIndex] = {
        ...updatedQuestions[questionIndex],
        q_answer: '',
      };
      setQuestions(updatedQuestions);
    }
    
    setQuestionChunksList([]);

    
  }

  const currentQuestion = questions[currentQuestionIndex];
  const headerStyle = {
    backgroundColor: '#edf2fb',
    padding: '2px',
    display: 'flex',  // Use flexbox for layout
    alignItems: 'center',  // Align items vertically in the center
    justifyContent: 'space-between',  // Add space between items
};

  return (
    <div className='user-qus-div'>
      <UserNav />
      <div style={{display:'flex',justifyContent:'end', alignItems:"end",marginTop:'5px'}}>
      <video ref={videoRef} width="180" height="150" />
      </div>
    <div style={{padding:'40px 15px', marginBottom:'20px'}}>
      <div className="question-div">
        <Row className="justify-content-center">
          <Col xs={12} md={12}>
            {questions.length !== 0 ? (
              <div>
                {/* <div className="text-right mt-3">
                  <p>Test Will End In : {endTimeInMilliseconds} Milliseconds</p>
                </div> */}
                <h2 className="text-center mb-4">Question {currentQuestion?.qid}</h2>
                <p className="text-center">{currentQuestion?.q_text}</p>

                <div className='d-flex'>
                  <div className="text-center mt-3 flex-grow-1">
                    <textarea
                      rows="7"
                      readOnly
                      className="form-control"
                      value={currentQuestion?.q_answer}
                      placeholder="Please speak to answer..."
                    />
                  </div>
                  <div style={{display:'grid'}}>
                  <div className="text-center align-self-center m-left">
                    <Button variant="dark" style={{padding:'10px 30px'}} onClick={() => handleClearAns(currentQuestion?.qid)} disabled={isRecording || timer <= 0}>
                      Clear
                    </Button>
                  </div>

                  <div className="text-center align-self-center m-left">
                    {/* <Button variant="outline-danger" onClick={handleMicClick}>
                      {isRecording ? <FaStop className="icon" /> : <FaMicrophone className='icon' />}
                    </Button> */}
                    {isRecording ? <Button variant="outline-success" style={{padding:'10px 40px'}} onClick={handleMicClick} >
                      <FaStop className="icon qes-icon-size"  /> </Button> : <Button variant="outline-danger" style={{padding:'10px 40px'}} onClick={handleMicClick} disabled={timer <= 0}>
                      <FaMicrophone className="icon qes-icon-size" /> </Button> }
                      {isRecording ? <>
                  <div className="text-center mt-3 speak-text">
                  <p style={{color:'green'}}> You are speaking</p>
                </div>
                </>:<>      <div className="text-center mt-3 speak-text">
                  <p style={{color:'red'}}> Click Mic to Speak</p>
                </div></>}
                {/* <Button variant="outline-dark" style={{padding:'10px 40px'}} onClick={startCapture} >
                      <FaVideo className="icon qes-icon-size"  /> </Button> */}
                  </div>

               
                  </div>

                </div>
          
                <div className="text-center mt-3">
                  <p style={{ color: timer <= 30 ? 'red' : '' }}>Time Remaining: {timer} seconds</p>
                </div>
                <div className="text-center mt-3">
                  {showSubmitButton ? (
                    <Button variant="primary" onClick={handleSubmit} disabled={isRecording || isGetAns}>
                      {currentQuestionIndex + 1}/{questions.length} Submit All Answers
                    </Button>
                  ) : (
                    <Button variant="dark" onClick={()=>handleNextQuestion('BUTTON','SUBMIT')} disabled={isRecording || isGetAns}>
                      {currentQuestionIndex + 1}/{questions.length} Next Question {isGetAns && <Spinner ></Spinner>}
                    </Button>
                  )}
                </div>
                {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
                <div>
                  {respError && <p className='error-msg'>{respError}</p>}
                </div>
              </div>
            ) : (
              <>
              <div>
                {error && <p className='error-qns-msg'>{error}</p>}
              </div>
              <div>
                {loading && (
                      <div className="spinner-overlay-qna">
                        <Spinner animation="border" role="status">
                          <span className="sr-only"></span>
                        </Spinner>
                      </div>
                    )}
            </div>
              </>
              
            ) 
            }
            
          </Col>
        </Row>
      </div>
    </div>
    <footer className='footer-div'>
      <p style={{color:'white'}}>&copy; 2024 Data Lake Solutions LLC. All rights reserved.</p>
      </footer>
    </div>

  );
};

export default UsersQuestions;

    